/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-did-mount-set-state */
import React, { Fragment } from 'react';
import Ad from '../../components/ad/ad';
import PropTypes from 'prop-types';
import { chunk } from 'lodash';

const Wrapper = ({ children, combinedAdModel }) => (
  <div className="post post--default">
    <div className="post__main">
      <div className="post_reco">
        <div className="post__container post__container--long">
          <div className="post__content">
            <section className="finite-scroll__recommended-articles">
              <div className="articles">{children}</div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <div className="post__sidebar sticky">
      <Ad
        {...combinedAdModel}
        noLazyLoad={true}
        pos="btf"
        name="flexibleportrait"
        canRefresh={true}
      />
    </div>
  </div>
);

class RecommendedArticles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      articleChunks: [],
      recoData1: undefined,
      recoData2: undefined,
      recoData3: undefined
    };
  }

  componentDidMount() {
    this.setState({
      articleChunks: chunk(this.props.articles, this.props.adSplit)
    });
  }

  componentDidUpdate(prevProps) {
    const self = this;

    // CHECK FOR NATIVE RECOMMENDATION LINKS >
    if (self.props.postNativeAd) {
      // reco link 1
      if (
        prevProps.postNativeAd.recommendations !==
          self.props.postNativeAd.recommendations &&
        self.props.postNativeAd.recommendations !== undefined
      ) {
        self.setState({
          recoData1: self.props.postNativeAd.recommendations
        });
      }
      // reco link 2
      if (
        prevProps.postNativeAd.recommendations_2 !==
          self.props.postNativeAd.recommendations_2 &&
        self.props.postNativeAd.recommendations_2 !== undefined
      ) {
        self.setState({
          recoData2: self.props.postNativeAd.recommendations_2
        });
      }
      // reco link 3
      if (
        prevProps.postNativeAd.recommendations_3 !==
          self.props.postNativeAd.recommendations_3 &&
        self.props.postNativeAd.recommendations_3 !== undefined
      ) {
        self.setState({
          recoData3: self.props.postNativeAd.recommendations_3
        });
      }
    }
  }

  // func to build native recommendation links from recoData in state
  buildNativeReco(recoData) {
    const eyebrow = (() => {
      let tagName = null;

      recoData.posts[0].tags.forEach(tag => {
        if (tag.name.includes('_advertorial')) {
          tagName = tag.name
            .replace(/^\*/gi, '')
            .replace(/_advertorial$/gi, '')
            .replace(/_/gi, ' ');
        }
      });

      return tagName;
    })();

    return (
      <article key={recoData.posts[0].title}>
        <div className="image">
          <a href={recoData.posts[0].link}>
            <img
              loading="lazy"
              width="140"
              height="79"
              src={recoData.posts[0].featured_image.source.replace(
                'w_1280',
                'w_220'
              )}
              alt={recoData.posts[0].title}
            />
          </a>
        </div>

        <div className="hed">
          <div className="eyebrow">
            {recoData.posts[0].customEyebrowText || `Presented by ${eyebrow}`}
          </div>
          <a href={recoData.posts[0].link}>{recoData.posts[0].title}</a>
        </div>
      </article>
    );
  }

  render() {
    const self = this;
    if (!self.state.articleChunks) return false;

    return (
      <Fragment>
        {this.state.articleChunks.map((articleChunk, i) => (
          <Fragment key={`articleChunk-${i}`}>
            {i !== 0 && (
              <div className="post__article-top-ad-wrapper">
                <Ad
                  {...self.props.combinedAdModel}
                  name="flexiblebillboard"
                  region="articlescroll"
                  ceros={false}
                  pos="btf"
                />
                <Ad
                  {...self.props.combinedAdModel}
                  name="mobileleaderboard"
                  region="articlescroll"
                  pos="btf"
                />
              </div>
            )}

            <Wrapper
              group={i}
              key={`articleChunk-${i}`}
              combinedAdModel={self.props.combinedAdModel}
            >
              {articleChunk.map((article, index) => (
                <Fragment key={`recoChunk-${index}`}>
                  {/* USING DATA FROM RETURNED NATIVE RECOMMENDATIONS ADs */}
                  {index === 3 &&
                    self.state.recoData1 !== undefined &&
                    self.buildNativeReco(self.state.recoData1)}
                  {index === 5 &&
                    self.state.recoData2 !== undefined &&
                    self.buildNativeReco(self.state.recoData2)}
                  {index === 8 &&
                    self.state.recoData3 !== undefined &&
                    self.buildNativeReco(self.state.recoData3)}

                  <article key={article.title}>
                    <div className="image">
                      <a href={article.url}>
                        <img
                          loading="lazy"
                          width="140"
                          height="79"
                          src={article.image_url.replace('w_1280', 'w_220')}
                          alt={article.title}
                        />
                      </a>
                    </div>

                    <div className="hed">
                      <div className="eyebrow">{article.section}</div>
                      <a href={article.url}>{article.title}</a>
                    </div>
                  </article>
                </Fragment>
              ))}
            </Wrapper>
          </Fragment>
        ))}
      </Fragment>
    );
  }
}

RecommendedArticles.propTypes = {
  articles: PropTypes.shape([]).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  adSplit: PropTypes.number,
  postNativeAd: PropTypes.shape({}).isRequired
};

Wrapper.propTypes = {
  combinedAdModel: PropTypes.shape({}).isRequired,
  group: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
};

RecommendedArticles.defaultProps = {
  adSplit: 0
};

export default RecommendedArticles;
